module.exports = __webpack_public_path__ + "static/media/dekton-white.82d7cc1b.svg";